<template>
  <modal :show.sync="showModal" header-classes="justify-content-center" @close="handleClose">
    <h4 slot="header" class="title title-up">
      End Discipleship Group
    </h4>
    <h2 v-if="error" style="color:red;">
      There was an error. Please refresh your page.
    </h2>
    <el-row>
      <label class="col-md-4 col-form-label">Select Discipleship Group</label>
      <el-select
        class="col-md-8 select-default"
        filterable
        clearable
        v-model="selectGroupId"
        placeholder="Select group..."
        @change="fetchCurrentParticipants(selectGroupId)"
      >
        <el-option
          v-for="item in groupsSelect"
          :key="item.group_id"
          :label="item.leader"
          :value="item.group_id"
        />
      </el-select>
    </el-row>
    <h4 class="card-title center" v-if="selectGroupId && selectedParticipants.length != 0">
      Participants
    </h4>
    <table class="table table-hover" v-if="selectGroupId && selectedParticipants.length != 0">
      <tbody>
        <tr
          v-for="participant in selectedParticipants"
          :key="participant.id"
        >
          <td style="width: 100%;">
            {{ participant.name }}
          </td>
        </tr>
      </tbody>
    </table>
    <br>
    <el-button type="primary" @click.native="validateEndGroup" v-if="selectGroupId">
      End this group
    </el-button>
    <p>
      <span v-if="validationError.disciple === true" style="color: red;">
        Please select a group.<br>
      </span>
      <span v-if="validationError.endGroup === true" style="color: red;">
        Please remove all participants before ending the group.<br>
      </span>
    </p>
  </modal>
</template>

<script>
import Modal from '../UIComponents/Modal';
import { RepositoryFactory } from '../../repositories/repositoryFactory';

const DiscipleshipGroupsRepository = RepositoryFactory.get('discipleshipGroups');

export default {
    name: 'EndDiscipleshipGroupModal',
    components: {
        Modal
    },
    data() {
        return {
            groupsSelect: [],
            showModal: false,
            validationError: {
                endGroup: false,
            },
            selectedParticipants: [],
            selectGroupId: '',
            error: '',
            saving: false,
            locationId: '',
        };
    },
    methods: {
        handleClose() {
            this.selectGroupId = '';
            this.newLeaderPersonId = '';
            this.newDiscipleType = '';
            this.validationError.disciple = false;
            this.validationError.endGroup = false;
            this.selectedParticipants = [];
            this.editParticipant = '';
            this.$emit('close');
        },
        handleEndGroup() {
            this.saving = true;
            DiscipleshipGroupsRepository.endDiscipleshipGroup(
                this.selectGroupId,
            )
                .then((response) => {
                    this.saving = false;
                    this.handleClose();
                    this.$emit('save');
                    this.$emit('close');
                    this.$message(response.data.message);
                })
                .catch((error) => {
                    this.saving = false;
                    this.handleClose();
                    this.$emit('close');
                    this.$message(error.response.data.message);
                });
        },
        validateEndGroup() {
            if (this.selectedParticipants.length !== 0) {
                this.validationError.endGroup = true;
            } else {
                this.handleEndGroup();
            }
        },
        getGroups() {
            this.isReady = false;
            DiscipleshipGroupsRepository.getDiscipleshipGroups(this.locationId)
                .then((response) => {
                    this.groupsSelect = response.data.data;
                    this.isReady = true;
                })
                .catch((error) => {
                    this.error = error.response.data.message;
                });
        },
        fetchCurrentParticipants(groupId) {
            if (groupId === '') {
                return;
            }
            DiscipleshipGroupsRepository.getCurrentParticipants(groupId)
                .then((response) => {
                    this.selectedParticipants = response.data.data;
                })
                .catch((error) => {
                    this.error = error;
                });
        },
    },
    props: {
        show: Boolean,
    },
    watch: {
        show(val) {
            this.showModal = val;
            if (this.showModal === true) {
                this.getGroups();
            }
        }
    }
};
</script>
